import React from 'react'
import PropTypes from 'prop-types'

import './ErrorSummary.scss'

const ErrorSummary = ({ children }) => (
  <div
    className='ErrorSummary'
    role='alert'
    style={{
      display:
        children && (children.length == null || children.length > 0)
          ? 'block'
          : 'none'
    }}
  >
    <span>
      <i className='fa fa-exclamation-triangle' />
      &nbsp;
      {children}
    </span>
  </div>
)

ErrorSummary.propTypes = {
  children: PropTypes.any
}

export default ErrorSummary
